import type { AxiosError } from 'axios';
import type { Campaign } from 'backend';
import { createQuery } from 'react-query-kit';

import { supabase } from '../../supabase-client';

type Response = Campaign;
type Variables = { id: string };

export const useCampaign = createQuery<Response, Variables, AxiosError>({
  queryKey: ['campaign'],
  fetcher: async ({ id }) => {
    const { data, error } = await supabase
      .from('campaigns')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  },
});
